import { AdminLayout } from "components/admin/admin-layout";
import { BaseSubscriptionInputs } from "components/admin/subscriptions/base-inputs";
import { SubscriptionPrices } from "components/admin/subscriptions/prices/prices-section";
import { useSubPriceReducer } from "lib/hooks/use-sub-price-reducer";
import { Button } from "components/buttons/button";
import {
  createEmptyState,
  saveDraftContent,
} from "components/text-editor/editor-utils";
import { EditorState } from "draft-js";
import { useAdminCreateSubMutation } from "lib/graphql-generated";
import {
  allInputsAreModified,
  inputsAreValid,
  someInputsAreModified,
  useInput,
} from "lib/hooks/use-input";
import slugify from "slugify";
import currency from "currency.js";
import { useRouter } from "next/router";

export const NewSubscription = () => {
  const router = useRouter();
  const title = useInput<string>(
    "",
    (v) => {
      if (v.trim() !== "") {
        return { valid: true };
      } else {
        return { valid: false, message: "Must have a title" };
      }
    },
    true
  );
  const description = useInput<EditorState>(createEmptyState());
  const isActive = useInput<boolean>(true);
  const image = useInput<string>(
    "",
    (v) => {
      if (v.trim() !== "") {
        return { valid: true };
      } else {
        return { valid: false, message: "Must have an image url" };
      }
    },
    true
  );
  const price = useInput<number>(
    0,
    (v) => {
      if (v > 0) {
        return { valid: true };
      } else {
        return { valid: false, message: "Price must be higher than 0" };
      }
    },
    true
  );
  const note = useInput<string>("");
  const [save, { loading: saving }] = useAdminCreateSubMutation();

  const isSaveDisabled =
    saving ||
    !inputsAreValid([title, image, price]) ||
    !allInputsAreModified([title, image, price]);

  const handleSave = () => {
    save({
      variables: {
        sub: {
          image: image.value,
          title: title.value,
          price: currency(price.value).intValue,
          slug: slugify(title.value, { lower: true, strict: true }),
          is_active: isActive.value,
          description: saveDraftContent(description.value),
        },
      },
    }).then((res) => {
      router.push(
        `/admin/subscriptions/${res.data.insert_subscriptions_one.id}`
      );
    });
  };

  return (
    <AdminLayout page='New Subscription'>
      <article className='space-y-4'>
        <header className='flex flex-row justify-between'>
          <h1 className='header text-4xl'>Creating New Subscription</h1>
          <section className='space-x-4'>
            <Button
              buttonType='primary'
              buttonSize='md'
              disabled={isSaveDisabled}
              onClick={handleSave}>
              Save
            </Button>
            <Button
              buttonType='ghost'
              buttonSize='md'
              href='/admin/subscriptions'>
              Cancel
            </Button>
          </section>
        </header>
        <form
          className='flex flex-row flex-wrap w-full space-y-4 lg:space-y-0 lg:grid lg:grid-cols-2 xl:grid-cols-3 lg:gap-4 xl:gap-8'
          onSubmit={handleSave}>
          <BaseSubscriptionInputs
            title={title}
            description={description}
            image={image}
            isActive={isActive}
            price={price}
            note={note}
          />
        </form>
      </article>
    </AdminLayout>
  );
};

export default NewSubscription;
